export default "__VITE_ASSET__DOeuRIrs__"